"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSortingLabel = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = require("../../Icon");

var _TabFocusTrap = require("../../TabFocusTrap/TabFocusTrap");

var _excluded = ["active", "children", "className", "direction", "testId"];
var styles = {
  "TableSortingLabel__button": "TableSortingLabel__TableSortingLabel__button___1bp8L",
  "TableSortingLabel__button__text": "TableSortingLabel__TableSortingLabel__button__text___Cg0gl",
  "TableSortingLabel__icon": "TableSortingLabel__TableSortingLabel__icon___dwu6n",
  "TableSortingLabel__icon--asc": "TableSortingLabel__TableSortingLabel__icon--asc___27th8",
  "TableSortingLabel__icon--desc": "TableSortingLabel__TableSortingLabel__icon--desc___L0Qns"
};

var TableSortingLabel = function TableSortingLabel(_ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      direction = _ref.direction,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'cf-ui-table-sorting-label' : _ref$testId,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var renderIcon = function renderIcon() {
    var classNames = (0, _classnames["default"])(styles['TableSortingLabel__icon'], styles["TableSortingLabel__icon--".concat(direction)]);
    return /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      className: classNames,
      icon: "ArrowUp",
      color: "muted"
    });
  };

  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
    type: "button",
    className: (0, _classnames["default"])(styles['TableSortingLabel__button'], className),
    "data-test-id": testId
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_TabFocusTrap.TabFocusTrap, {
    className: styles['TableSortingLabel__button__text']
  }, children, active && renderIcon()));
};

exports.TableSortingLabel = TableSortingLabel;